import { H3, WrapLgMarginBottom } from "App/global-style";
import {
  getCollectionOfDittoComponents,
  useTexts,
} from "Components/TextContext";

import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import React from "react";
import { AkaHealthProductPriceFormValues } from "./akaHealthProductPriceInterfaces";

interface Props {
  formProps: FormikProps<AkaHealthProductPriceFormValues>;
  isPriceLoading: boolean;
}

const { akahealth: coverageCardTextComponents } =
  getCollectionOfDittoComponents(TextComponentNameLevel1.COVERAGE_CARD);

export const AkaHealthCoverages = ({
  formProps,
  isPriceLoading,
}: Props): React.ReactElement => {
  const coverages = useCoveragePriceCalculations();
  const { getText } = useTexts();

  return (
    <WrapLgMarginBottom>
      <H3>{getText("coveragecard.subheaders.choosecoverage")}</H3>
      {coverages.map(([insurance, coverage]) => (
        <DittoCoverageCard
          key={`coverage-card_${insurance}`}
          fieldName="coverage"
          product={ProductBackendName.AKA_HEALTH}
          coverage={insurance}
          textComponents={coverageCardTextComponents}
          prices={coverage.prices}
          priceIsLoading={isPriceLoading}
        />
      ))}

      {isDefined(formProps.values.coverage) && (
        <CurrentPriceMessage
          productBackendName={ProductBackendName.AKA_HEALTH}
          coverages={coverages}
          selectedPrices={[
            {
              selectedCoverage: formProps.values.coverage,
              selectedDeductible: undefined,
              defaultDeductible: undefined,
            },
          ]}
        />
      )}
    </WrapLgMarginBottom>
  );
};
